import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useModules(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getPlanModules() {
    return privateFetch.get(`/v1/admin/available/modules`, configs).then((res) => res.data);
  }

  return useQuery('plan-modules', getPlanModules, { enabled });
}

export default useModules;
